import CommonService from "../services/common.service";

export function getRfqAssignedManagerAccessUserId(row) {
  const id = row?.assignedLogisticsManagerAccessUserId ?? row?.assignedLogisticsManagerId;
  const parsed = Math.trunc(Number(id));
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export function getRfqAssignedLogisticsUserAccessUserId(row) {
  const id = row?.assignedLogisticsUserId ?? row?.assignedLogisticsUserAccessUserId;
  const parsed = Math.trunc(Number(id));
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export function hasAssignedLogisticsUser(row) {
  const name = String(row?.assignedLogisticsUserName || "").trim();
  return Boolean(name) || getRfqAssignedLogisticsUserAccessUserId(row) != null;
}

export function hasAssignedLogisticsTeamUser(row, managerAccessUserId = null) {
  const userId = getRfqAssignedLogisticsUserAccessUserId(row);
  if (!userId) {
    return false;
  }
  const managerId = getRfqAssignedManagerAccessUserId(row);
  if (managerId && userId === managerId) {
    return false;
  }
  const currentId = Math.trunc(Number(managerAccessUserId));
  if (Number.isFinite(currentId) && currentId > 0 && userId === currentId) {
    return false;
  }
  return true;
}

export function getRfqProviderAssignmentOwnerAccessUserId(row) {
  const userId = getRfqAssignedLogisticsUserAccessUserId(row);
  const managerId = getRfqAssignedManagerAccessUserId(row);
  if (userId && hasAssignedLogisticsTeamUser(row)) {
    return userId;
  }
  return managerId;
}

export function isRfqAssignedToLogisticsManager(row, managerAccessUserId) {
  const assignedManagerId = getRfqAssignedManagerAccessUserId(row);
  const currentId = Math.trunc(Number(managerAccessUserId));
  if (!assignedManagerId || !Number.isFinite(currentId) || currentId < 1) {
    return false;
  }
  return assignedManagerId === currentId;
}

export function canAssignLogisticsProvidersForRow(row, staffAccessUserId) {
  const ownerId = getRfqProviderAssignmentOwnerAccessUserId(row);
  const staffId = Math.trunc(Number(staffAccessUserId));
  return ownerId != null && Number.isFinite(staffId) && staffId > 0 && ownerId === staffId;
}

export function canViewProviderAssignmentsForRow(row, staffAccessUserId) {
  if (!Number(row?.assignedProviderCount)) {
    return canAssignLogisticsProvidersForRow(row, staffAccessUserId);
  }
  const staffId = Math.trunc(Number(staffAccessUserId));
  if (!Number.isFinite(staffId) || staffId < 1) {
    return false;
  }
  return (
    canAssignLogisticsProvidersForRow(row, staffAccessUserId) ||
    isRfqAssignedToLogisticsManager(row, staffAccessUserId) ||
    getRfqAssignedLogisticsUserAccessUserId(row) === staffId
  );
}

/** @deprecated Use canAssignLogisticsProvidersForRow */
export function canLogisticsManagerAssignProviders(row, managerAccessUserId) {
  return canAssignLogisticsProvidersForRow(row, managerAccessUserId);
}

/** @deprecated Use canViewProviderAssignmentsForRow */
export function canLogisticsManagerViewProviderAssignments(row, managerAccessUserId) {
  return canViewProviderAssignmentsForRow(row, managerAccessUserId);
}

export async function fetchLogisticsStaffAccessUserId() {
  const res = await CommonService.get("/logistics-manager/me", {}, { silent: true });
  const body = res?.data ?? res;
  const manager = body?.manager ?? body?.data?.manager;
  const user = body?.user ?? body?.data?.user;
  const id = manager?.accessUserId ?? user?.accessUserId;
  const parsed = Math.trunc(Number(id));
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export async function fetchLogisticsManagerAccessUserId() {
  return fetchLogisticsStaffAccessUserId();
}
